import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../../billing/billingService.service';
import {  takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BillSearchList } from '../../billing/Models/billing.Models';
import { SelectionModel } from '@angular/cdk/collections';
import * as moment from 'moment';
import { IPDService } from '../Services/ipdServices.service';


@Component({
  selector: 'app-search-ipd-patient',
  templateUrl: './search-ipd-patient.component.html',
  styleUrls: ['./search-ipd-patient.component.scss']
})
export class SearchIpdPatientComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
    selectId:any;
    PatientListArray:any=[];
    maxDate;
    startdate:any;
    enddate:any;
    todaysdate = this.authService.getServerDate;
    displayedColumns: string[] = ['ipNo','branchCode','ipdAdmDate','dod','doctor','fK_RegId',
    'patientName','sex','referredBy','ward'];
     dataSource = new MatTableDataSource<any>();
     selection = new SelectionModel<any>(true, []);

  constructor(public dialog: MatDialog,  public dashboardService: DashboardService, public datepipe: DatePipe,
    public authService: AuthService, private datePipe: DatePipe, public ipdService:IPDService,
    public opdvisitService: OpdVisitService,private billingservice: BillingserviceService) { }
   
       
   

  ngOnInit(): void {
    this.ipdService.selectePatientData =null;
    this.startdate= this.dashboardService.selecteddate; 
    this.enddate = this.dashboardService.selecteddate;
    this.getpatientdetails(this.startdate,this.enddate,this.authService.Loggeduser.branchid);
    this.maxDate = moment(this.authService.getServerDate).format('YYYY-MM-DD')  
 
   }

  getpatientdetails(a,b,c){
    this.ipdService.getLastAddmittedpateintdetails(a,b,c).subscribe(data=>this.allPatientsuccsess(data),err=>this.allpatienterrors(err))
   }

   allPatientsuccsess(data){
    this.PatientListArray = data;
    this.dataSource.data = this.PatientListArray.reverse();
    
  }
  allpatienterrors(err){
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
 }
  closedialog(){
    this.dialog.closeAll();
    }



    
setbillgetdata(){
  
  let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
  let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
  console.log(sdate,edate)
  this.getpatientdetails(sdate,edate,this.authService.Loggeduser.branchid)


}
applyFilter_grid(filterValue){
  this.dataSource.filter = filterValue.trim().toLowerCase();

}

isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.data.length;
  return numSelected === numRows;
}
   

ngOnDestroy() {
  this.destroy$.next(true);
  // Unsubscribe from the subject
  this.destroy$.unsubscribe();
}
  
    /** Selects all rows if they are not all selected; otherwise clear selection. */
       masterToggle() {
       this.isAllSelected() ?
       this.selection.clear() :
       this.dataSource.data.forEach(row => this.selection.select(row));
     }

    selectRow(row) {
      this.selection.toggle(row);
      this.ipdService.selectePatientData = row;
      console.log(this.ipdService.selectePatientData);
      this.dialog.closeAll();
    }

   
}

